 
export enum DisbursementSchedule {
  IMMEDIATE = 'IMMEDIATE',
  WEEKLY = 'WEEKLY'
}
